import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component';
import { ButtonComponent } from '@components/button/button.component';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { LinkComponent } from '@components/link/link.component';
import { ProgressStep } from 'app/interfaces/progress-step.interface';
import { ProgressBarComponent } from '@components/progress-bar/progress-bar.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { Display } from 'app/interfaces/display.interface';
import { DisplaysService } from 'app/services/displays.service';

@Component({
  selector: 'app-displays-list-item',
  standalone: true,
  templateUrl: './displays-list-item.component.html',
  styleUrl: './displays-list-item.component.scss',
  imports: [CommonModule, BadgeStatusComponent, TranslateModule, LinkComponent, ButtonComponent, ConfirmModalComponent, ProgressBarComponent]
})
export class DisplaysListItemComponent implements OnInit {
  @Input() display: Display;
  public displayActions!: any;
  public isConfirmModalVisible: boolean = false;
  public step: number = 1;

  public modalTitle: string = 'my_displays.remove_display';
  public modalMessage: string = 'my_displays.confirmation_remove_display';

  progressStatusses = ['DRAFT', 'IN_PROGRESS', 'INVOICED', 'PENDING_CONFIRMATION', 'INSTALLED'];

  public pendingOperation: 'remove' | 'requestDeletion' | 'cancelDeletion' | null = null;

  public progressSteps: ProgressStep[] = [
      { title: 'my_displays.progress_step_1' },
      { title: 'my_displays.progress_step_2' },
      { title: 'my_displays.progress_step_3' },
      { title: 'my_displays.progress_step_4' },
      { title: 'my_displays.progress_step_5' },
  ];

  private nextStep(): void {
    if (this.step < this.progressSteps.length) {
      this.step++;
    }
  }

  public getCurrentStep(status: string): number {
    if (status === 'INVOICED' && this.display.mainPhotoUrl !== null) {
      status = 'PENDING_CONFIRMATION';
    }
    if(status === 'DISCONTINUED') {
      status = 'INSTALLED';
    }
    const index = this.progressStatusses.indexOf(status) + 1;
    return index !== -1 ? index : 0;
  }

  constructor(private displaysService: DisplaysService, private translate: TranslateService) {}

    private translations(){
      this.translate.get([
          'my_displays.progress_step_1',
          'my_displays.progress_step_2',
          'my_displays.progress_step_3',
          'my_displays.progress_step_4',
          'my_displays.progress_step_5',
          'my_displays.remove_display',
          'my_displays.confirmation_remove_display',
          'my_displays.display_cancel_delete_btn',
      ])
    }

  public ngOnInit(): void {
    this.displayActions = this.displaysService.getDisplayActions(this.display);
  }

  public removeDisplay(): void {
    console.log(`Removing display with ID: ${this.display.id}`);
    this.displaysService.removeDisplay(this.display);
    this.isConfirmModalVisible = false;
  }

  public handleClick(operation: string) {
    console.log(`Operation: ${operation}`);
    if (operation === 'completeDisplay') {
      this.displaysService.completeDisplay(this.display.id).subscribe();
      return;
    }

    if (operation === 'removeDisplay' && this.canRemoveDisplay()) {
      // Mostramos modal para confirmar operación
      this.pendingOperation = 'remove';
      this.modalTitle = 'my_displays.remove_display';
      this.modalMessage = 'my_displays.confirmation_remove_display';
      this.isConfirmModalVisible = true;
      return;
    }

    if (operation === 'requestDeletion') {
      this.pendingOperation = 'requestDeletion';
      this.modalTitle = 'my_displays.remove_display';
      this.modalMessage = 'my_displays.confirmation_remove_display';
      this.isConfirmModalVisible = true;
      return;
    }

    if (operation === 'cancelDeletion') {
      this.pendingOperation = 'cancelDeletion';
      this.modalTitle = 'my_displays.display_cancel_delete_btn';
      this.modalMessage = '';
      this.isConfirmModalVisible = true;
      return;
    }

    if (operation === 'requestRenewal') {
      this.displaysService.requestRenewal(this.display.id).subscribe();
      return;
    }
  }

  public confirmOperation(): void {
    if (this.pendingOperation === 'remove') {
      this.removeDisplay();
    }

    if (this.pendingOperation === 'requestDeletion') {
      this.displaysService.requestDeletion(this.display).subscribe();
    }

    if (this.pendingOperation === 'cancelDeletion') {
      this.displaysService.cancelDeletion(this.display).subscribe();
    }

    this.pendingOperation = null;
    this.isConfirmModalVisible = false;
  }


  private canRemoveDisplay(): boolean {
    const isInstalled = this.display.status === 'INSTALLED';
    const hasExceededMinDays = this.display.daysSinceInstalled > 540;

    return (isInstalled && hasExceededMinDays) || !isInstalled;
  }

  getFirstInstallationDate(items: any[]): string | null {
    if (!items) return null;
    const date = items.find(item => !!item.installationDate)?.installationDate;
    return date || null;
  }
}
